import {stringify} from "qs";

import {logRejection} from "services-comun/modules/decorators/metodo";

import {FrontendRequest} from "../frontend-backend";
import {IEncuesta, Encuesta} from "./encuesta";
import dominio from "../../portal/ed";

export class EncuestasWebFrontendRequest extends FrontendRequest {
    /* STATIC */
    private static SERVICIO: string = dominio.get(dominio.SERVICES);

    @logRejection(true)
    public static async votar(encuesta: number, opcion: string): Promise<Encuesta> {
        const params = stringify({
            encuesta,
            opcion,
        });
        return Encuesta.build(await this.get<IEncuesta>(`${this.SERVICIO}/web/encuestas/votar/?${params}`));
    }

    /* INSTANCE */
}
